module.exports = __webpack_public_path__ + "img/ico_chuantouxiang.687615b9.svg";